import { zeroAddress } from 'viem'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const PLASMA = {
  name: 'plasma',
  chainId: 9745,
  averageBlockTimeSeconds: 1,
  explorerUrl: 'https://plasmascan.to/',
  nativeAsset: {
    assetAddress: zeroAddress,
    decimals: 18,
    name: 'Plasma',
    symbol: 'XPL',
  },
  slip44: 60,
  wrappedNativeAsset: '0x6100E367285b01F48D07953803A2d8dCA5D19873',
  blockscoutApiUrl: 'https://api.routescan.io/v2/network/mainnet/evm/9745/etherscan/api',
  etherscanSupported: false,
  publicRpcUrls: ['https://rpc.plasma.to'],
  getPrivateRpcUrls: () => {
    const plasma: string[] = []
    process.env.ROUTEME_API_KEY && plasma.push(`https://lb.routeme.sh/rpc/9745/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('plasma')
    quickNodeUrl && plasma.push(quickNodeUrl)
    process.env.ALCHEMY_API_KEY && plasma.push(`https://plasma-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return plasma
  },
} as const satisfies ChainConfig
